<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div>
        <div v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable
            cusClass="text-box m-0"
            :loading="loading"
            width="100%"
            :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN"
            v-model="company"
            :options="items"
            :total="total"
            @keyup="emitEvent"
            @offset="changeOffset"
            :disabled="mode == 'edit'"
          />
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Tên khu vực</label>
          <InputText v-model="name" type="text" class="text-box input-text-box" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)" />
          <input class="input_tmp_validator" id="name" />
        </div>
        <div class="mt-3">
          <Checkbox v-model="active" :binary="true" />Hiển thị
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-warning return-style-button" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()" class="p-button-success main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from "@/components/DropdownScrollable.vue";
import ApiRepository from "@/core/ApiRepository";

export default {
  components: {
    DropdownScrollable,
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      filters: {},
      name: "",
      active: true,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      company_id: null,
    };
  },
  async mounted() {
    await this.getListCompany();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.company = this.model.company;
      this.active = this.model.active;
      this.name = this.model.name;
    } else if (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) {
      this.$set(this, "company_id", this.$store.getters?.company_id);
      this.company = { id: this.company_id };
    }
  },
  watch: {
    async company_id() {
      if (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.company = { id: this.company_id };
      }
    },
    async "$store.getters.company_id"() {
      if (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) {
        this.$set(this, "company_id", this.$store.getters?.company_id);
        this.company = { id: this.company_id };
      }
    },
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, "name");
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      if (token) {
        const headers = {
          Authorization: "Bearer " + token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", { filters: this.filters, limit: 20, offset: this.offset, company_id: this.company.id }, { headers })
          .then((res) => {
            if (this.offset > 0) {
              this.items.push(...res.data.data.company);
            } else {
              this.items = res.data.data.company;
            }
            this.total = res.data.data.total;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (this.$commonFuction.isEmptyObject(this.company) || this.$commonFuction.isEmpty(this.company)) {
          company_add.setCustomValidity("Vui lòng chọn công ty!");
        } else {
          company_add.setCustomValidity("");
        }
      }
      let name_add = document.getElementById("name");
      if (!this.name) {
        name_add.setCustomValidity("Vui lòng nhập tên khu vực!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên khu vực không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var params = {
        name: this.name,
        active: this.active,
        company: this.company,
      };
      this.$emit("save", params);
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.p-checkbox {
  margin-right: 1rem !important;
}
</style>
